import Cookies from 'js-cookie'
import {CookieConfig} from "../config";
import { v4 as uuidv4 } from 'uuid';


let id: string | null = null


export function getUserIdentity(config: CookieConfig){
    const c = Cookies.get(config.name)
    if (id){
        return id;
    }
    if (c) {
        id =c;
        return c
    } else {
        id = uuidv4();
        Cookies.set(config.name,id)
        return id;
    }

}
